<template>
  <main :class="{ boxPadding: isBox }">
    <customer-info
      :loading="false"
      :loading_from_family="family_loading"
      @passAddressData="getAddress"
      @passIsRelation="getRelation"
      @initDetailTwo="initCustomerDetail2()"
    />
    <tab-header :current="currentTab" />
    <div class="tab-content" :class="{ 'section-loading': loading_1 }">
      <div class="container-fluid">
        <div class="tab-pane active show">
          <!-- 無家戶 -->
          <div class="empty-block family bg-white" v-if="familyResult.length == 0">
            <h3>{{ CustInfo.name }}尚未屬於任何一個家戶</h3>
            <a @click="addToFamily()" class="btn btn-primary">加入現有家戶</a>
            <!-- <a class="btn btn-primary" :disabled=true @click="createFamily()">成立新的家戶</a> -->
            <button
              type="button"
              class="btn btn-primary"
              :disabled="closeCreateButton"
              @click="createFamily()"
            >
              成立新的家戶
            </button>
          </div>

          <!-- 有家戶 -->
          <div v-else>
            <div class="row mb-3" v-if="isEdit">
              <div class="col-auto mr-auto">
                <a class="btn btn-red btn-sm m-0 ml-2 btn-left mr-auto" @click="panelOpen('mvDeleteFamilyOpen')"
                  >解散家戶</a
                >
              </div>
              <div class="col-auto">
                <span style="vertical-align: sub;" :set="(del = familyResult.filter(x => x.isDelete))">
                  {{ _.isEmpty(del) ? '' : `提醒：本次儲存後，將移除${del.length}位家戶成員` }}
                </span>
                <a @click="editCancer" class="btn btn-default btn-sm m-0 mr-2 ml-2">取消</a>
                <a @click="saveChange" class="btn btn-primary btn-sm m-0 mr-2">儲存</a>
              </div>
            </div>

            <div class="row" v-else>
              <div class="col-12 mb-3">
                <a @click="isEdit = true" class="btn btn-default btn-sm btn-icon m-0 float-right">
                  <i class="icon-edit"></i>
                </a>
              </div>
            </div>
            <div class="row" v-if="!loading_1">
              <template v-for="(member, rid) in familyResult">
                <div class="col-md-3" v-if="!member.isDelete" :key="`family-card-${rid}`">
                  <div class="card">
                    <a class="close" v-if="isEdit && member.familyrl > 0" @click="doDelete(member)">
                      <i class="icon-close"></i>
                    </a>
                    <h3 v-if="!member.csidno">{{ getTruncateText(member.name, 12, true) }}</h3>
                    <h3 v-else>
                      <a
                        class="link text-underline"
                        v-on:click="routeToCustDetail(member.name, member.serNo || member.csidno)"
                        >{{ getTruncateText(member.name, 12, true) }}</a
                      >
                    </h3>
                    <div class="content">
                      <div class="desc role" :style="isEdit ? 'margin-bottom: 10px;' : ''">
                        <avatar :gender="Number(member.sex)" :size="20" />
                        <span class="text" v-if="isEdit">
                          <select
                            v-model="member.familyrl"
                            v-validate="'required'"
                            :name="`familyrl-${rid}`"
                            :class="{ 'is-invalid': errors.has(`familyrl-${rid}`) }"
                            class="form-control form-control-inline form-short"
                          >
                            <option v-for="(value, key, index) in roleOpt" :value="key" :key="`role-select-${index}`">{{
                              value
                            }}</option>
                          </select>
                        </span>
                        <span class="text" v-else>{{ roleOpt[member.familyrl] }}</span>
                        <b class="float-right">{{ member.age }}歲</b>
                      </div>
                      <div class="d-flex justify-content-end align-items-center refresh-wrapper" v-if="!isEdit">
                        <i class="fas fa-sync"></i>
                        <b class="orange" @click="doReGroup(member)">重新歸戶</b>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="col-md-3 d-flex flex-column" v-if="!isEdit">
                <div class="card add d-flex align-items-center" @click="addCustFromExist">
                  <i class="icon-add_new text-orange i-32"></i>
                  <p>加入現有客戶</p>
                </div>
                <div class="card add d-flex align-items-center" @click="addCustFromNewCreate">
                  <i class="icon-add_new text-orange i-32"></i>
                  <p>新增客戶</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <!-- 編輯客戶基本資料 -->
    <contact-info-modal
      comp-name="CustomerDetail"
      :open="custInfoOpen"
      :inputs="CustInfo"
      :addressData="addressData"
      :isRelation="isRelation"
      @submit="constInfoSubmit"
      @close="panelClose('custInfoOpen')"
    />

    <!-- 移除成員確認 -->
    <mv-delete-single :open="mvDeleteModalOpen" @close="closeDeleteModal" @confirm="closeDeleteModal('Y')">
      <div class="text font-cust" slot="content">
        <div>
          您要移除家戶成員
          <span class="text-green">{{ deleteMem.name }}</span>
          嗎？
        </div>
      </div>
    </mv-delete-single>

    <!-- 解散家戶確認 -->
    <mv-delete-family
      :isFinalDelete="checkDeleteFamilyModal"
      :open="mvDeleteFamilyOpen"
      @close="closeMvFamilyDeleteModal()"
      @confirm="closeMvFamilyDeleteModal('O')"
    >
      <div class="text mb-5 font-cust" slot="content">
        <div v-if="!checkDeleteFamilyModal">
          您要解散以
          <span class="text-green">{{ leaderName }}</span>
          為戶長的家戶嗎？若解散家戶，原家戶成員皆需重新歸戶。
        </div>
        <div v-else>
          此家戶將被解散，所有成員將需重新歸戶。確定要解散此家戶嗎？
        </div>
      </div>
    </mv-delete-family>

    <!-- 重新歸戶確認 -->
    <mv-add-family-modal
      :open="mvReGroupFamOpen"
      :csidno="reGroupId"
      @close="panelClose('mvReGroupFamOpen')"
      @confirm="panelOpen('mvReGroupFamOpen')"
    />

    <!-- 離開頁面彈窗 -->
    <leave-page-warning-modal
      :open="leavePageWarningModalOpen"
      ref="leavePageWarningModal"
      message="編輯資料尚未儲存，請問是否繼續編輯？<br>若要儲存編輯資料請留在本頁面並點擊畫面<span style='color: #f58818;'>橘色</span>的「儲存」按鈕"
      cancelText="離開"
      submitText="是"
      @submit="panelClose('leavePageWarningModalOpen')"
      @close="panelClose('leavePageWarningModalOpen')"
    >
    </leave-page-warning-modal>

    <mv-mask :open="mvMaskOpen" :content="mvMaskContent" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '../../mixins/common';
import {
  modifyFamilyMember,
  getFamilyMemberByCsidNo,
  getAllHouseholderBySales,
  createNewFamily,
  editCustInfo,
  deleteFamily,
  getCustInfo
} from '../../service/index';
import moment from 'moment';
import { computeAge } from '@/service/index';
import Avatar from '../../components/Avatar';
import CustomerInfo from '../components/CustomerDetail/CustomerInfo';
import TabHeader from '../components/CustomerDetail/TabHeader';
import ContactInfoModal from '../components/ContactInfoModal';
import mvDeleteSingle from '@/desktop/views/mv/components/mvDelete';
import mvDeleteFamily from '@/desktop/views/mv/components/mvDelete';
import mvAddFamilyModal from '@/desktop/views/mv/components/mvAddFamilyModal';
import leavePageWarningModal from '@/desktop/views/mv/components/leavePageWarningModal';
import mvMask from '@/desktop/views/mv/components/mvMask';

export default {
  name: 'CustomerDetail',
  mixins: [commonMixin],
  data() {
    return {
      //req_id用來將id noid 整合發request
      family_loading: false,
      req_id: '',
      custInfoOpen: false,
      loading_1: true,
      currentTab: 0,
      customer: {},
      roleOpt: {
        0: '戶長',
        1: '配偶',
        2: '子女',
        3: '父母',
        4: '其他',
        5: '孫子女'
      },
      familyResult: [],
      fromBox: false, //不透過客戶連結，直接由 App 存取
      originalFamilyResult: [],
      addressData: {},
      isRelation: false,
      isEdit: false,
      mvDeleteModalOpen: false,
      deleteMem: {},
      mvReGroupFamOpen: false,
      reGroupId: '',
      leaderName: '',
      mvMaskContent: '',
      mvMaskOpen: false,
      // 解散家戶第一次彈窗
      checkDeleteFamilyModal: false,
      // 解散家戶第二次彈窗
      mvDeleteFamilyOpen: false,
      leavePageWarningModalOpen: false,
      closeCreateButton: false
    };
  },
  filters: {
    dataFormat(value) {
      if (value === '' || value === '--') {
        return '— —';
      } else {
        let dt = value.replace(/\/.*/g, '');
        let today = window.moment();
        return today.year() - 1911 - dt;
      }
    }
  },
  components: {
    Avatar,
    CustomerInfo,
    TabHeader, // basic component
    ContactInfoModal,
    mvDeleteSingle,
    mvDeleteFamily,
    mvAddFamilyModal,
    mvMask,
    leavePageWarningModal
  },
  computed: {
    ...mapGetters(['BaseUrl', 'CustInfo', 'UserInfo']),
    isBox() {
      // 判斷是否為 box
      return (this.UserInfo.userType === 'box') || this.fromBox;
    }
  },
  methods: {
    ...mapActions([
      'updateUserItems',
      'setPageLock',
      'updateCustID',
      'updateSerNo',
      'updateCustInfo',
      'updateFamilyResultFilter',
      'updateLastFamilyResult'
    ]),
    doDelete(memData) {
      this.panelOpen('mvDeleteModalOpen');
      this.deleteMem = memData;
    },
    closeDeleteModal(val) {
      if ('Y' == val) {
        this.deleteMem.isDelete = true;
      }
      this.panelClose('mvDeleteModalOpen');
    },
    // 解散家戶彈窗關閉，二次彈窗顯示
    closeMvFamilyDeleteModal(type) {
      this.panelClose('mvDeleteFamilyOpen');
      if (!this.checkDeleteFamilyModal && type == 'O') {
        window.setTimeout(() => {
          this.panelOpen('mvDeleteFamilyOpen');
          this.checkDeleteFamilyModal = true;
        }, 100);
      } else if (this.checkDeleteFamilyModal && type != 'O') {
        window.setTimeout(() => {
          this.checkDeleteFamilyModal = false;
        }, 100);
      } else if (this.checkDeleteFamilyModal && type == 'O') {
        this.deleteFamily();
      } else {
        this.checkDeleteFamilyModal = false;
      }
    },
    deleteFamily() {
      this.mvMaskContent = '解散家戶中';
      this.panelOpen('mvMaskOpen');
      deleteFamily(this.$store.state.userInfo.id, this.familyResult).then(result => {
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: '家戶已解散' });
          this.initCustomerDetail2();
        } else {
          this.$toast.info({ title: '家戶解散失敗' });
        }
        this.panelClose('mvMaskOpen');
      });
    },
    editCancer() {
      this.isEdit = false;
      // 回壓原始資料
      this.familyResult.forEach(item => {
        const csidno = item.csidno;
        item.familyrl = this.originalFamilyResult.find(x => x.csidno == csidno).familyrl;
        item.isDelete = false;
      });
    },
    saveChange() {
      if (!this.saveValid()) {
        return;
      }
      this.mvMaskContent = '家戶資料編輯中';
      this.panelOpen('mvMaskOpen');
      modifyFamilyMember(
        this.$store.state.userInfo.id,
        this.familyResult,
        this.familyResult.filter(x => x.isDelete).length,
        false
      ).then(result => {
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: '編輯成功' });
          this.panelClose('mvMaskOpen');
          this.initCustomerDetail2(false);
        } else {
          if (result.header && result.header.message) {
            let errorMessage = result.header.message;
            errorMessage = errorMessage.split('Message: ')[1].split(' ')[0];
            this.$toast.info({ title: errorMessage });
          }
          this.panelClose('mvMaskOpen');
        }
      });
    },
    saveValid() {
      this.errors.items.length = 0;
      const leaderNumber = this.familyResult.filter(x => !x.isDelete && Number(x.familyrl) === 0).length;
      const multiSpouse = this.familyResult.filter(x => !x.isDelete && Number(x.familyrl) === 1).length > 1;
      this.familyResult.forEach((item, index) => {
        if (!item.isDelete) {
          if ((leaderNumber > 1 && Number(item.familyrl) === 0) || (multiSpouse && Number(item.familyrl) === 1)) {
            this.errors.add({
              field: `familyrl-${index}`,
              msg: 'familyrl'
            });
          } else if (leaderNumber == 0) {
            this.errors.add({
              field: `familyrl-${index}`,
              msg: 'familyrl'
            });
          }
        }
      });
      let title = '';
      if (leaderNumber > 1 && multiSpouse) {
        title = '僅能有一位「戶長」和一位「配偶」，請再次確認家戶成員的身份';
      } else if (leaderNumber == 0 && multiSpouse) {
        title = '家中需有一位「戶長」且「配偶」僅能有一位，請再次確認';
      } else if (leaderNumber == 0) {
        title = '家中需有一位「戶長」，請再次確認';
      } else if (leaderNumber > 1) {
        title = '僅能有一位「戶長」，請再次確認家戶成員的身份';
      } else if (multiSpouse) {
        title = '僅能有一位「配偶」，請再次確認家戶成員的身份';
      }
      if (title != '') {
        this.$toast.info({
          title: title
        });
        return false;
      }
      return true;
    },
    // 重新歸戶
    doReGroup(member) {
      const lastFamily = this.familyResult.filter(x => x.csidno != member.csidno);
      this.updateLastFamilyResult(lastFamily);
      this.updateFamilyResultFilter([member]);
      this.setHistory('customer-detail-2', 'addToFamily');
      this.setHistory('customer-detail-2', 'createNewFamily');
      this.$store.state.isPageFromMv = false;
      this.reGroupId = member.csidno;
      // 無其他家戶成員則直接導向加入現有客戶
      if (window._.isEmpty(lastFamily)) {
        this.addToFamily();
      } else {
        this.panelOpen('mvReGroupFamOpen');
      }
    },
    // 加入現有客戶
    addToFamily() {
      getAllHouseholderBySales(this.$store.state.userInfo.id).then(result => {
        const getAllOtherResult = result.data.filter(item => item.csidno != this.req_id);
        //若完全沒有任何家戶，點擊後返回前頁，並顯示警示訊息「尚未建立任何家戶」
        if (window._.isEmpty(getAllOtherResult)) {
          this.$toast.info({ title: '尚未建立任何家戶' });
          return;
        } else {
          this.setHistory('customer-detail-2', 'addToFamily');
          let Birthday_data = '';
          if (this.CustInfo.birthday) {
            Birthday_data = this.CustInfo.birthday;
          }
          let list = [
            {
              id: this.req_id,
              csidno: this.req_id,
              birthday: Birthday_data,
              birthdayROC: moment(Birthday_data).toDate(),
              sex: this.CustInfo.gender,
              name: this.CustInfo.name,
              age: this.CustInfo.age
            }
          ];
          this.updateFamilyResultFilter(window._.isEmpty(this.familyResult) ? list : this.familyResult);
          this.$store.state.isPageFromMv = false;
          this.$router.push({
            name: 'addToFamily',
            params: {
              isReAddFamily: true
            }
          });
        }
      });
    },
    // 成立新的家戶
    createFamily() {
      if(!this.closeCreateButton){
        this.closeCreateButton = true

        if (this.checkValue(this.CustInfo)) {
          let Birthday_data = '';
          if (this.CustInfo.birthday) {
            Birthday_data = this.CustInfo.birthday;
          }
          let list = [
            {
              id: this.req_id,
              csidno: this.req_id,
              birthday: Birthday_data,
              birthdayROC: moment(Birthday_data).toDate(),
              sex: this.CustInfo.gender,
              name: this.CustInfo.name,
              age: this.CustInfo.age,
              familyrl: 0
            }
          ];
          // this.mvMaskContent = "家戶建立中，請稍候...";
          // this.panelOpen("mvMaskOpen");
          createNewFamily(this.$store.state.userInfo.id, this.req_id, list).then(result => {
            if (result && result.header.status === '200' && result.header.message) {
              this.$toast.info({ title: result.header.message });
              this.initCustomerDetail2();
              // this.closeCreateButton = false
              // this.panelClose("mvMaskOpen");
            } else {
              this.$toast.info({ title: result.header.message });
              this.initCustomerDetail2();
              // this.closeCreateButton = false
              // this.panelClose("mvMaskOpen");
            }
          });
        }
      }
    },
    addCustFromExist() {
      this.setHistory('customer-detail-2', 'familyAddCust');
      this.$store.state.isPageFromMv = false;
      this.$router.push({
        name: 'familyAddCust',
        params: {
          allFamilyNumber: this.familyResult.length
        }
      });
    },
    addCustFromNewCreate() {
      this.setHistory('customer-detail-2', 'createCust2Family');
      this.$store.state.isPageFromMv = false;
      this.$router.push({
        name: 'createCust2Family',
        params: {
          familyResult: this.familyResult,
          hasSpouse: this.familyResult.some(obj => obj.familyrl === 1)
        }
      });
    },
    routeToCustDetail(custName, csid) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(csid, custName);
      } else {
        if (!csid.includes('~')) {
          this.updateCustID(csid);
          this.updateSerNo('');
          localStorage.CustID = csid;
          localStorage.SerNo = '';
        } else {
          this.updateCustID('');
          this.updateSerNo(csid);
          localStorage.CustID = '';
          localStorage.SerNo = csid;
        }
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    // 變更客戶基本資料
    constInfoSubmit(custInfo) {
      this.panelClose('custInfoOpen');
      this.family_loading = true;

      let custNo = this.$store.state.custInfo.ID || '';
      editCustInfo(this.$store.state.userInfo.id, custNo, custInfo, null).then(result => {
        const resMessage = result.header.message;
        if (result.header && result.header.status === '200') {
          getCustInfo(this.$store.state.userInfo.id, this.$store.state.userInfo.id, custInfo.ID || custInfo.serNo).then(
            result => {
              this.setCustInfo(result.body.customer);
              this.family_loading = false;
              this.$toast.info({ title: `${resMessage}` });
              this.$emit('initDetailTwo');
              this.initCustomerDetail2();
            }
          );
        } else {
          this.family_loading = false;
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: `${resMessage}` });
          }
        }
      });
    },
    //接Box參數，查詢客戶資料
    getCustInfoFromBox(csid){
      this.fromBox = true;
      this.updateCustID(atob(csid));
      this.initCustomerDetail2();
    },
    //告知APP 頁面已加載完畢
    isReadyListenAppJS () {
      this.$nextTick(() => {
        if (window.webkit) {
          window.webkit.messageHandlers.isReadyListenAppJS.postMessage("isOK");
        }
      });
    },
    checkValue(custInfo) {
      const ageEmpty = custInfo.age == '' && custInfo.age !== 0;
      const genderEmpty = custInfo.gender == '' || custInfo.gender == '0' || custInfo.gender == 0;
      if (!ageEmpty && !genderEmpty) {
        return true;
      }
      if (genderEmpty || ageEmpty) {
        let msg;
        if (ageEmpty && genderEmpty) {
          msg = '缺少「性別、生日或年齡」，無法建立家戶';
        } else if (ageEmpty) {
          msg = '缺少「生日或年齡」，無法建立家戶';
        } else {
          msg = '缺少「性別」，無法建立家戶';
        }
        this.$toast.info({
          title: msg
        });
        this.panelOpen('custInfoOpen');
        this.closeCreateButton = false
        return false;
      }
    },
    setCustInfo(user) {
      let custInfo = {
        lv: Number(user.vip_lvl || '0'),
        familyLeader: false,
        name: user.name || '',
        gender: user.sex || 0,
        birthday: user.birthday || '',
        ID: user.id || '',
        age: user.age == 0 || user.age ? user.age : '',
        serNo: user.ser_no || '',
        lineid: user.lineid || '',
        mobile: user.mobile ? user.mobile.trim() : '',
        phone: [user.home_tel_area ? user.home_tel_area.trim() : '', user.home_tel ? user.home_tel.trim() : ''],
        office_phone: [
          user.corp_tel_area ? user.corp_tel_area.trim() : '',
          user.corp_tel ? user.corp_tel.trim() : '',
          user.corp_tel_ext ? user.corp_tel_ext.trim() : ''
        ],
        fax: [user.fax_area ? user.fax_area.trim() : '', user.fax ? user.fax.trim() : ''],
        // fax: '',
        address: [
          user.home_addr_zip ? user.home_addr_zip.trim() : '',
          user.home_addr1 ? user.home_addr1.trim() : '',
          user.home_addr2 ? user.home_addr2.trim() : '',
          user.home_addr3 ? user.home_addr3.trim() : ''
        ],
        office_address: [
          user.corp_addr_zip ? user.corp_addr_zip.trim() : '',
          user.corp_addr1 ? user.corp_addr1.trim() : '',
          user.corp_addr2 ? user.corp_addr2.trim() : '',
          user.corp_addr3 ? user.corp_addr3.trim() : ''
        ],
        wg_name: user.wg_name || '',
        relation: {
          source1: user.relation.source1,
          source2: user.relation.source2,
          source3: user.relation.source3,
          source4: user.relation.source4,
          source5: user.relation.source5,
          source6: user.relation.source6
        }
      };
      this.updateCustInfo(custInfo);
    },
    getAddress(val) {
      this.addressData = val;
    },
    getRelation(val) {
      this.isRelation = val;
    },
    initCustomerDetail2(reGetCust = true) {
      if (reGetCust) {
        this.family_loading = true;
      }
      this.loading_1 = true;
      if (this.CustInfo.ID !== '') {
        this.req_id = this.CustInfo.ID;
      } else {
        this.req_id = this.CustInfo.serNo;
      }
      getFamilyMemberByCsidNo(this.$store.state.userInfo.id, this.req_id).then(familyResult => {
        if (familyResult.header && familyResult.header.status === '200' && familyResult.data) {
          const familyLeader = familyResult.data.find(obj => {
            return obj.familyrl === 0;
          });
          this.updateUserItems(familyLeader);
          this.leaderName = familyLeader && familyLeader.name ? familyLeader.name : '';
          // 更新localStorage戶長資料
          localStorage.userItems = JSON.stringify(familyLeader);

          familyResult.data.forEach(ele => {
            ele['isDelete'] = false;
            if (ele.birthday) {
              ele['birthdayROC'] = moment(ele.birthday).toDate();
            }
            if (!ele.csidno.includes('~')) {
              ele['isCsidno'] = true;
            } else {
              ele['serNo'] = ele.csidno;
            }
            // 若無年齡資料，則利用生日來換算
            if (!ele.age && ele.birthday) {
              computeAge(this.$store.state.userInfo.id, window.moment(ele.birthday).format('YYYY-MM-DD')).then(
                result => {
                  if (result.header && result.header.status == '200') {
                    ele.age = result.body.age;
                  } else {
                    ele.age = '';
                  }
                }
              );
            }
          });

          this.familyResult = familyResult.data;
          this.familyResult.sort((a, b) => {
            return String(a.familyrl).localeCompare(String(b.familyrl)) || b.age - a.age;
          });
          this.originalFamilyResult = window._.cloneDeep(this.familyResult);
          this.closeCreateButton = false
        } else {
          this.familyResult = [];
          this.closeCreateButton = false
        }

        // 重查客戶基本資料
        if (reGetCust) {
          getCustInfo(
            this.$store.state.userInfo.id,
            this.$store.state.userInfo.id,
            this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo
          ).then(result => {
            this.setCustInfo(result.body.customer);
            this.family_loading = false;
          });
        }

        this.loading_1 = false;
        this.editCancer();
        this.registerHanlink();
      });
    }
  },
  beforeMount() {
    let routeNumber = this.$route.name.split(/-/g).reverse();
    this.currentTab = Number(routeNumber[0]);
  },
  mounted() {
    if (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo) {
      this.initCustomerDetail2();
    }

    if (this.$store.state.userInfo.userType === 'box') {
      //接Box參數
      window.getCustInfoFromBox = (data) => {
        this.getCustInfoFromBox(data);
      };
      this.isReadyListenAppJS();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.panelOpen('leavePageWarningModalOpen');
      this.$nextTick(() => {
        this.$refs.leavePageWarningModal.$once('submit', () => {
          next(false);
        });
        this.$refs.leavePageWarningModal.$once('close', () => {
          next();
        });
      });
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  flex: 1;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #989ca2;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);
  &.add {
    cursor: pointer;
    border: 1px solid #eaeaea;
  }
  h3 {
    margin: 0 0 18px 0;
  }
  .close {
    cursor: pointer;
    position: absolute;
    right: 0px;
    top: -12px;
    display: block;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 22px;
    color: white;
    background: #5b616a;
    border: 2px solid #fff;
    border-radius: 12px;
    -webkit-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    -ms-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    -o-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  }

  .desc.role img,
  .cards .card .desc.role .text {
    vertical-align: middle;
    margin-right: 10px;
  }

  div.desc.role {
    min-height: 38px;
  }

  &.add {
    p {
      margin-left: 10px;
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }
}

.boxPadding {
  padding-top: 0px !important;
}

.refresh-wrapper {
  margin-bottom: 10px;
  min-height: 21px;
  b {
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #f58818;
  }

  .fas.fa-sync {
    cursor: pointer;
    color: #f58818;
    margin-right: 4px;
    font-size: 15px;
  }
}
</style>
